<template>
  <landing-page label="factSheet.fattyLiverTitle" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'fattyLiverLandingImage', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div v-html="t('factSheet.fattyLiverDesc')" class="space-y-12" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.fattyLiverSymptoms") }}</div>
      <div v-html="t('factSheet.fattyLiverSymptomsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.maintainAnOptimalWeight") }}</div>
      <div v-html="t('factSheet.maintainAnOptimalWeightDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.balancedDiet") }}</div>
      <div v-html="t('factSheet.balancedDietDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.phyicallyActive") }}</div>
      <div v-html="t('factSheet.phyicallyActiveDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.refrainFromDrinking") }}</div>
      <div v-html="t('factSheet.refrainFromDrinkingDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.controlDiabetes") }}</div>
      <div v-html="t('factSheet.controlDiabetesDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.normalBloodLipidLevels") }}</div>
      <div v-html="t('factSheet.normalBloodLipidLevelsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.medicationsCarefully") }}</div>
      <div v-html="t('factSheet.medicationsCarefullyDesc')" class="space-y-5" />
    </div>

    <div v-html="t('factSheet.fattyLiverRef')" class="space-y-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.fattyLiver") }}</div>
      </div>

      <div v-html="t('factSheetChinese.fattyLiverDesc')" class="space-y-12" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.fattyLiverSymptoms") }}</div>
        <div v-html="t('factSheetChinese.fattyLiverSymptomsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.maintainAnOptimalWeight") }}</div>
        <div v-html="t('factSheetChinese.maintainAnOptimalWeightDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.balancedDiet") }}</div>
        <div v-html="t('factSheetChinese.balancedDietDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.phyicallyActive") }}</div>
        <div v-html="t('factSheetChinese.phyicallyActiveDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.refrainFromDrinking") }}</div>
        <div v-html="t('factSheetChinese.refrainFromDrinkingDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.controlDiabetes") }}</div>
        <div v-html="t('factSheetChinese.controlDiabetesDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.normalBloodLipidLevels") }}</div>
        <div v-html="t('factSheetChinese.normalBloodLipidLevelsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.medicationsCarefully") }}</div>
        <div v-html="t('factSheetChinese.medicationsCarefullyDesc')" class="space-y-5" />
      </div>

      <div v-html="t('factSheetChinese.fattyLiverRef')" class="space-y-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>